import { NgModule } from "@angular/core";
import { CameraFormComponent } from './camera-form/camera-form.component';
import { DynamicCameraComponent } from './dynamic-camera.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { CameraDesignComponent } from './camera-design/camera-design.component';
import { CameraResultComponent } from './camera-result/camera-result.component';

@NgModule({
    declarations: [
        CameraResultComponent,
        CameraDesignComponent,
        CameraFormComponent, DynamicCameraComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule
    ],
    entryComponents: [
        DynamicCameraComponent
    ]
})
export class CameraModule {}